import { render, staticRenderFns } from "./SubCategoryTypes.vue?vue&type=template&id=23d034a4&"
import script from "./SubCategoryTypes.vue?vue&type=script&lang=js&"
export * from "./SubCategoryTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports